// @flow

import React from 'react';
import Badge from 'sail/Badge';
import Text from 'sail/Text/Text';
import type {VideoModel} from 'docs/data';
import TRANSCRIPT from './transcript.json';
import './VideoTranscript.scss';

type VideoTranscriptProps = {|
  currentTime: number,
  video: VideoModel,
|};

const parseTimestamp = (timestampString) => {
  const [min, seconds] = timestampString.split(':');
  return Number(min) * 60 + Number(seconds);
};

export const VideoTranscript = ({currentTime, video}: VideoTranscriptProps) => {
  const transcriptRef = React.useRef(null);

  const activeTimestampRef = React.useCallback((node) => {
    const transcriptDiv = transcriptRef ? transcriptRef.current : null;
    if (node && transcriptDiv) {
      // The transcript is in a container so this auto scrolls
      // to keep the active timestamp in the middle
      transcriptDiv.scrollTop =
        node.offsetTop -
        transcriptDiv.offsetTop -
        transcriptDiv.getBoundingClientRect().height / 2;
    }
  }, []);

  const markers = TRANSCRIPT.map((line, index) => {
    // NOTE - this is just a proof of concept, when we know what the transcripts
    // actually look like we can have them include start and end times to make
    // this simpler
    const timestamp = parseTimestamp(line.time);
    const nextTimestamp = TRANSCRIPT[index + 1]
      ? parseTimestamp(TRANSCRIPT[index + 1].time)
      : 0;

    const isActiveTimestamp =
      currentTime >= timestamp && currentTime <= nextTimestamp;

    return (
      <div
        key={`${line.time}-${index}`}
        className="VideoTranscript-marker"
        ref={isActiveTimestamp ? activeTimestampRef : null}
      >
        <Badge
          color={isActiveTimestamp ? 'blue' : 'gray'}
          className="VideoTranscript-marker-time"
          label={line.time}
        />
        <Text>{line.text}</Text>
      </div>
    );
  });

  return (
    <div className="VideoTranscript" ref={transcriptRef}>
      {markers}
    </div>
  );
};
